export function Checkbox({
  checked,
  onChange,
  label,
  id,
  inputClassName,
}: {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  id: string;
  inputClassName?: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        className={`w-6 h-6 accent-primary cursor-pointer ${inputClassName}`}
        checked={checked}
        onChange={onChange}
        id={id}
      />
      <label
        htmlFor={id}
        className="text-text-primary text-sm md:text-base font-normal cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
}
